import { Combobox } from "@/components/ui/combobox";
import { useListClientBrokerAccountNumbers } from "@/lib/api/customer";

/**
 * One account code, picked like ManageCustomers' RJO account number: the unassigned account
 * numbers, plus the record's current code when it isn't among them.
 */
export function AccountCodeSelect({
  value,
  onChange,
  disabled,
}: {
  value: string[];
  onChange: (codes: string[]) => void;
  disabled: boolean;
}) {
  const accountNumbersResult = useListClientBrokerAccountNumbers();
  const activeAccountCode = value[0] ?? "";
  const unassignedAccountNumberList: string[] = accountNumbersResult.data?.success
    ? accountNumbersResult.data.data.unassignedAccountNumberList
    : [];

  const activeOptions = activeAccountCode && !unassignedAccountNumberList.includes(activeAccountCode)
    ? [{ value: activeAccountCode, label: activeAccountCode }]
    : [];
  const accountNumberOptions = [
    ...activeOptions,
    ...unassignedAccountNumberList.map((accountNumber) => ({ value: accountNumber, label: accountNumber })),
  ].sort((a, b) => a.label.localeCompare(b.label));
  const failedToLoad = accountNumbersResult.isError || accountNumbersResult.data?.success === false;

  return (
    <div className="space-y-1">
      <Combobox
        isModal
        dwimOnChange
        virtualizeList
        popoverClassName='md:min-w-[300px] lg:min-w-[400px] xl:min-w-[500px]'
        className="w-full"
        placeholder={accountNumbersResult.isLoading ? "Loading account numbers…" : "—"}
        options={accountNumberOptions}
        value={activeAccountCode}
        onValueChange={(accountCode: string) => onChange(accountCode ? [accountCode] : [])}
        disabled={disabled}
      />
      {failedToLoad && <p className="text-xs text-red-600">Couldn't load the available account numbers.</p>}
    </div>
  );
}
